module.exports = __webpack_public_path__ + "static/media/industries-recycling-s.0c690b76.webp";